import { useState, useEffect, useCallback } from 'react';

interface DisplayResultNumberProps {
  resultNumber: number | undefined;
  fromNumber?: number;
  handleCallbackAnimation?: () => void;
}

const DURATION = 1500;

export const DisplayResultNumber = ({ resultNumber, fromNumber = 0, handleCallbackAnimation }: DisplayResultNumberProps) => {
  const [showResultNumbers, setShowResultNumbers] = useState<string>('');

  useEffect(() => {
    showCount(fromNumber, resultNumber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromNumber, resultNumber]);

  const getDecimalPointLength = useCallback((number: number): number => {
    return (String(number).split('.')[1] || '').length;
  }, []);

  const showCount = useCallback(
    (from: number, to: number | undefined): void => {
      if (to === undefined) {
        return;
      }

      if (!Number.isFinite(from) || !Number.isFinite(to)) {
        return;
      }

      const isIncrement = from < to;
      const increment = Math.abs(to - from);
      const decimalPointLength = getDecimalPointLength(increment);
      const startTime = performance.now();

      const count = () => {
        const elapsed = performance.now() - startTime;
        const countValue = parseFloat(
          (isIncrement ? from + (elapsed / DURATION) * increment : from - (elapsed / DURATION) * increment).toFixed(decimalPointLength)
        );

        if ((isIncrement && countValue >= to) || (!isIncrement && countValue <= to)) {
          setShowResultNumbers(to.toString());
        } else {
          setShowResultNumbers(countValue.toString());
          requestAnimationFrame(count);
        }
      };

      requestAnimationFrame(count);
      setTimeout(() => handleCallbackAnimation?.(), DURATION);
    },
    [getDecimalPointLength, handleCallbackAnimation]
  );

  return <span>{showResultNumbers ? showResultNumbers : 0}</span>;
};
